import React, { useState } from "react";
import { LOGIN_ROUTE } from "../appMode";
import { useNavigate } from "react-router-dom";

import {
  FetchFromServer,
  UpdateToServer
} from "../api/ServerApi";
import {
  sanitizeMobileInput,
  mobileValidationError,
  openOtpWhatsApp,
  OTP_SENDER_WHATSAPP,
} from "../utils/mobileNumber";



function ForgotPassword() {
  const [mobile, setMobile] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [busy, setBusy] = useState(false);



  const navigate = useNavigate();

  const sendOtp = async () => {
    const cleaned = sanitizeMobileInput(mobile);
    const mobileError = mobileValidationError(cleaned);
    if (mobileError) return alert(mobileError);
    setMobile(cleaned);

    setBusy(true);
    try {
      // Check the account exists FIRST. OTP messages are billed per send, and
      // the old order sent one to any number then failed with "User not found"
      // at the very end.
      // GetUserDetailsbyMobileNumber lives only under /api/, hence open:true —
      // without it this 404s wherever the app talks to Express directly.
      let userData;
      try {
        userData = await FetchFromServer(
          "GetUserDetailsbyMobileNumber",
          { MobileNumber: Number(cleaned) },
          { plain: true, open: true }
        );
      } catch (err) {
        console.error("Account lookup failed", err);
        alert("Could not reach the server. Please check your connection and try again.");
        return;
      }

      if (!Array.isArray(userData) || userData.length === 0) {
        alert(
          `${cleaned} is not registered.

Please create a new account instead.`
        );
        return;
      }

      if (!window.confirm(`Send an OTP on WhatsApp to ${cleaned} to reset your password?`)) {
        return;
      }

      let result;
      try {
        result = await FetchFromServer(
          "SendOtpOnWhatsAppbyMobileNumber",
          { MobileNumber: cleaned, ServiceBy: "SmartSearch" }
        );
      } catch (err) {
        console.error("sendOtp error", err);
        alert("Could not reach the server. Please check your connection and try again.");
        return;
      }

      // Success is an ARRAY carrying the OTP; every failure is an OBJECT with a
      // `status`, and both come back as HTTP 200.
      if (!Array.isArray(result) || result.length === 0 || !result[0].Otp) {
        const status = result && !Array.isArray(result) ? result.status : null;
        console.error("OTP request rejected:", result);

        if (status === "Invalid Mobile Number") {
          alert(`The server rejected "${cleaned}" as a mobile number. It must be exactly 10 digits.`);
        } else if (status === "failed") {
          alert("The WhatsApp OTP service did not accept the request. Please try again in a few minutes.");
        } else {
          alert("Could not send the OTP. Please try again in a few minutes.");
        }
        return;
      }

      localStorage.setItem("reset_otp", String(result[0].Otp));
      localStorage.setItem("reset_mobile", cleaned);
      setOtpSent(true);
    } finally {
      setBusy(false);
    }
  };

const resetPassword = async () => {
  const storedOtp = localStorage.getItem("reset_otp");
  const storedMobile = localStorage.getItem("reset_mobile");

  if (!otp || !newPassword || !confirmPassword)
    return alert("Please fill all fields.");

  if (otp.trim() !== String(storedOtp || "").trim())
    return alert("Incorrect OTP.");

  // The app uses a 4-digit numeric password everywhere; without this the reset
  // could set something login would never accept.
  if (!/^\d{4}$/.test(newPassword))
    return alert("Password must be exactly 4 numeric digits.");

  if (newPassword !== confirmPassword)
    return alert("The two passwords do not match.");

  // Step 1: Fetch UserId from mobile number (open /api/ route only)
  let userData;
  try {
    userData = await FetchFromServer(
      "GetUserDetailsbyMobileNumber",
      { MobileNumber: Number(storedMobile) },
      { plain: true, open: true }
    );
  } catch (err) {
    console.error("Account lookup failed", err);
    return alert("Could not reach the server. Please try again.");
  }

  const userId = Array.isArray(userData) ? userData[0]?.UserId : undefined;

  if (!userId) return alert("User not found.");

  // ✅ Step 2: Make the update password API call.
  // UpdateUsers expects the raw-update shape {data, where} — passing
  // {UserId, Password} updated nothing.
  try {
    const updateResult = await UpdateToServer("UpdateUsers", {
      data: { Password: newPassword },
      where: `UserId = ${Number(userId)}`,
    });

    // Step 3: Handle result. The endpoint returns a MySQL result object.
    const result = Array.isArray(updateResult) ? updateResult[0] : updateResult;
    const ok =
      result?.status === "Success" ||
      result?.status === true ||
      Number(result?.affectedRows) > 0;

    if (ok) {
      localStorage.removeItem("reset_otp");
      localStorage.removeItem("reset_mobile");
      alert("Password updated successfully.");
      navigate(LOGIN_ROUTE);
    } else {
      alert("Failed to update password.");
    }
  } catch (err) {
    console.error("Password reset failed", err);
    alert("Failed to update password.");
  }
};


  return (
    <div style={styles.body}>
      <div style={styles.container}>
        <div style={styles.title}>Reset Password</div>
        <div style={styles.loginBox}>
          {!otpSent ? (
            <>
              <input
                type="tel"
                name="MobileNumber"
                autoComplete="tel"
                inputMode="numeric"
                placeholder="Registered Mobile Number"
                value={mobile}
                onChange={(e) => setMobile(sanitizeMobileInput(e.target.value))}
                maxLength={10}
                style={styles.input}
                disabled={busy}
              />
              <button
                onClick={sendOtp}
                disabled={busy}
                style={{ ...styles.button, ...styles.login, opacity: busy ? 0.6 : 1 }}
              >
                {busy ? "Please wait..." : "Send OTP"}
              </button>
            </>
          ) : (
            <>
              <div style={styles.sentBox}>
                OTP sent on WhatsApp to <b>{mobile}</b>
                <div style={{ fontSize: 12, marginTop: 4, opacity: 0.85 }}>
                  It arrives from <b>+{OTP_SENDER_WHATSAPP}</b>
                </div>
              </div>

              <button
                type="button"
                onClick={openOtpWhatsApp}
                style={{ ...styles.button, ...styles.whatsapp }}
              >
                Open WhatsApp to read the OTP
              </button>

              <input
                type="text"
                inputMode="numeric"
                placeholder="Enter OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                style={styles.input}
              />
              <input
                type="password"
                autoComplete="new-password"
                inputMode="numeric"
                placeholder="New 4-digit Password"
                value={newPassword}
                onChange={(e) => {
                  if (/^\d{0,4}$/.test(e.target.value)) setNewPassword(e.target.value);
                }}
                maxLength={4}
                style={styles.input}
              />
              <input
                type="password"
                autoComplete="new-password"
                inputMode="numeric"
                placeholder="Confirm New Password"
                value={confirmPassword}
                onChange={(e) => {
                  if (/^\d{0,4}$/.test(e.target.value)) setConfirmPassword(e.target.value);
                }}
                maxLength={4}
                style={styles.input}
              />
              <button onClick={resetPassword} style={{ ...styles.button, ...styles.login }}>
                Reset Password
              </button>
            </>
          )}
          <button onClick={() => navigate(LOGIN_ROUTE)} style={{ ...styles.button, ...styles.create }}>
            Back to Login
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  body: {
    backgroundImage: 'url("https://wallpapers.com/images/hd/usa-chicago-riverwalk-at-night-1jaq0bwc5dc0g6n0.jpg")',
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundAttachment: "fixed",
    margin: 0,
    fontFamily: "Helvetica, Arial, sans-serif",
    minHeight: "100vh",
    overflowY: "auto",
  },
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
    padding: "24px 12px",
    boxSizing: "border-box",
  },
  title: {
    fontSize: "26px",
    color: "white",
    fontWeight: "bold",
    marginBottom: "10px",
  },
  loginBox: {
    background: "rgba(255,255,255,0.1)",
    padding: "20px",
    width: "340px",
    borderRadius: "8px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
    textAlign: "center",
  },
  input: {
    width: "100%",
    padding: "9px 12px",
    margin: "4px 0",
    border: "1px solid #ddd",
    borderRadius: "6px",
    fontSize: "15px",
    boxSizing: "border-box",
  },
  button: {
    width: "100%",
    padding: "10px",
    marginTop: "6px",
    fontSize: "15px",
    fontWeight: "bold",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
  },
  login: {
    backgroundColor: "#1877f2",
    color: "white",
  },
  create: {
    backgroundColor: "#42b72a",
    color: "white",
  },
  whatsapp: {
    backgroundColor: "#25D366",
    color: "white",
  },
  sentBox: {
    background: "rgba(37, 211, 102, 0.15)",
    border: "1px solid rgba(37, 211, 102, 0.6)",
    color: "white",
    borderRadius: 6,
    padding: "8px 10px",
    margin: "4px 0 2px",
    fontSize: 13,
  },
};

export default ForgotPassword;
